import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const openBasketOverviewStyle = css`
cse-list cse-selectable {
    width: 100%;

    .item-heading {
      display: grid;
      grid-template-columns: auto;
      grid-row-gap: ${csSpacing.spacing05};
      text-align: left;
    }
    .item-content {
      display: grid;
      grid-template-columns: 1fr auto;
      grid-column-gap: ${csSpacing.spacing05};
      padding-top: ${csSpacing.spacing05};

      .columns {
        display: grid;
        grid-template-columns: auto 1fr;
        grid-column-gap: ${csSpacing.spacing05};
        grid-row-gap: ${csSpacing.spacing05};
        text-align: left;
        
        .last-activity-date {
          display: grid;
          grid-template-columns: auto;
`
